import { ITest } from "../../interface/IConfig";
import { DATA_INIT } from "../../interface/TStatus";

const tests: ITest[] = [
  {
    request: {
    httpMethod: "DELETE",
    queryStringParameters: {condition: {id: "###apiKeyId###"}},
    headers: {
        "Content-Type": "application/json; charset=utf8",
        "Accept-Encoding": "gzip, deflate, sdch",
        "Accept-Language": "en-US,en;q=0.8",
        Origin: "http://localhost:3000",
        "x-api-key": "###apiKey###",
        Cookie: "###authorizationKey###",
      },
      body: {
        name: "test-key",
        domain: "example.com",
        key: "aRndKey",
        app: "###app###",
        state: "active"
      },
        path: "/apikey",
    },
    response: {
      statusCode: 200,
      headers: { 
      "Access-Control-Allow-Headers": "Content-Type, X-Amz-Date, Authorization, X-Api-Key, X-Amz-Security-Token, X-Amz-User-Agent",
      "Access-Control-Allow-Origin": "http://localhost:3000",
      "Access-Control-Request-Method": "OPTIONS, POST, GET, PATCH, PUT, DELETE",
      "content-length": "54",
      "content-type": "application/json" },
      body: {
        data: {id: "###apiKeyId###"},
      },
    },
    status: DATA_INIT,
  },
];

export default tests;